import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { IPaymentMethodsEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IPaymentMethodsEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.paymentMethods");

export const paymentMethods = {
  ...getAllApis,
};
